import { render, staticRenderFns } from "./edit-charge-amount.vue?vue&type=template&id=6e971f08&scoped=true"
import script from "./edit-charge-amount.vue?vue&type=script&lang=js"
export * from "./edit-charge-amount.vue?vue&type=script&lang=js"
import style0 from "./edit-charge-amount.vue?vue&type=style&index=0&id=6e971f08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e971f08",
  null
  
)

export default component.exports